import { Component } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  CheckboxComponent,
  DatePipe,
  FormComponent,
  FormRowComponent,
  InputGroupComponent,
  InputGroupFieldComponent,
  InputGroupLabelComponent,
  NotificationComponent
} from '@tdwb/core';
import { AgreementsDateBaseDirective } from '../agreements.base';

@Component({
  selector: 'td-wb-usotc-agreement',
  templateUrl: './usotc-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  imports: [
    NgTemplateOutlet,
    FormsModule,
    NotificationComponent,
    DatePipe,
    FormComponent,
    FormRowComponent,
    InputGroupComponent,
    InputGroupLabelComponent,
    InputGroupFieldComponent,
    CheckboxComponent
  ]
})
export class UsotcAgreementComponent extends AgreementsDateBaseDirective {
}
